<template>
  <div class="cartcontrol">
		<transition name="move"> 
    <div class="cart-decrease icon-remove_circle_outline" v-show="food.count"	@click.stop="decreaseCart"></div>
		</transition>
    <div class="cart-count"  v-show="food.count">{{food.count}}</div>
      <div 
        class="cart-add icon-add_circle"	@click.stop.prevent="increaseCart">
        <i class="bg"></i>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default { 
  name: 'HelloWorld',
  data () {
	    return {
	      postInfo: {},
	    }
	},
	methods: {
		decreaseCart(){
			if(this.food.count > 0){
				console.log(this.food.count)
				this.food.count--
			}
		},
		increaseCart(){
			console.log(this.lock)
			if(this.selectCount > this.cartNum){
				var info = "购物车商品数量已经达到"+ this.cartNum +"个"
				this.$emit("showTips",info)
				return
			}
			if(this.food.stock <= 0){
				var info = "已达到该货道可出货商品的最大数量"
				this.$emit("showTips",info)
				return
			}

			if(!this.food.count){
				if(this.selectCount <= this.cartNum){
					console.log('*')
					Vue.set(this.food,'count',1)
				}else{
					var info = "购物车商品数量已经达到"+this.cartNum+"个"
					this.$emit("showTips",info)
				}
			}else{
				if(this.food.count < this.food.stock && this.selectCount <= this.cartNum){
					console.log("**")
					console.log(this.selectCount)
					this.food.count++
				}else{
					if(this.food.count >= this.food.stock){
						var info = "已达到该货道可出货商品的最大数量"
						this.$emit("showTips",info)
					}else if(this.selectCount > this.cartNum){
						var info = "购物车商品数量已经达到"+this.cartNum+"个"
						this.$emit("showTips",info)
					}
				}
			}
			
		}
	},
	props:{
		food:{
			type:Object
		},
		selectCount:{
			type:Number
		},
		c_num:{
			type:String
		},
		imei:{
			type:String
		},
		lock:{
			type:String
		},
		lock_times:{
			type:Number
		},
		cartNum:{
			type:Number
		}
	}
}
</script>


<style scoped>
@import url('../../common/css/style.css');
.cartcontrol{
	font-size: 0;
}

.cartcontrol .cart-decrease{
	display: inline-block;
	width: 26px;
	height: 26px;
	font-size: 26px;
	color: #b4b4b4;
}

.cartcontrol .cart-add .bg{
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background: black;
	position: absolute;
	left: 3px;
	top: 3px;
	z-index: -1;
}


.cartcontrol .cart-count{
	display: inline-block;
	width: 25px;
	text-align: center;
	font-size: 12px;
	line-height: 26px;
	vertical-align: top;
}

.cartcontrol .cart-add{
	display: inline-block;
	width: 26px;
	height: 26px;
	font-size: 26px;
	color: #ffd161;
	position: relative;
}
.move-enter-active,.move-leave-active{
	transition: all 0.3s linear;
}
.move-enter,.move-leave-to{
	transform: translateX(20px) rotate(180deg);
}
</style>


// WEBPACK FOOTER //
// src/components/cartcontrol/Cartcontrol.vue